import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import ArticleCard from '@/components/base/ArticleCard';
import { articles, categories } from '@/mocks/articles';
import { heroImage } from '@/mocks/article-images';

export default function Home() {
  const featuredArticle = articles[0];
  const recentArticles = articles.slice(1);

  const faqItems = [
    {
      q: '什么是正常的性欲水平？',
      a: '性欲是一个非常个体化的指标，不存在放之四海而皆准的正常标准。性欲受多种因素影响，包括激素水平、心理状态、人际关系质量、生活压力、药物使用等。建议关注的是自身性欲的变化趋势和是否对生活造成了困扰，而非与他人比较。如果你对自身性欲水平感到担忧，咨询专业医生或性治疗师是更好的选择。',
    },
    {
      q: '做爱频率多少才算正常？',
      a: '做爱频率同样因人而异。研究表明，伴侣间的性行为频率从每月一次到每天多次都可能属于正常范围。影响频率的因素包括年龄、关系阶段、工作压力、健康状况等。更重要的是双方对频率的满意度——如果彼此都感到满意，那么任何频率都是合适的。当出现显著差异时，建议通过开放沟通来寻找平衡点。',
    },
    {
      q: '如何与伴侣讨论性方面的困扰？',
      a: '选择合适的时间和地点至关重要——确保双方都处于放松、不被打扰的状态。使用我语句表达感受而非指责对方，例如：我最近感觉我们的亲密时刻变少了，有些想念，而不是你最近都不愿意亲近我。同时要给予对方充分表达的空间，保持倾听和理解的态度。如果沟通困难，可以考虑寻求专业的性治疗师或咨询师的帮助。',
    },
    {
      q: '性生活中感到疼痛该怎么办？',
      a: '性交疼痛（医学上称为性交困难）是一个需要认真对待的医学问题，不应被忽视或忍耐。可能的原因包括润滑不足、感染、激素变化、盆底肌肉紧张、心理因素等。首先建议停止引起疼痛的行为，然后及时就医，由妇科医生或泌尿科医生进行专业评估。在问题解决前，伴侣可以探索不涉及插入的亲密方式。',
    },
  ];

  const siteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '做爱指南',
    url: 'https://c8p0.cn',
    description: '做爱指南：提升亲密关系质量的科学方法。从科学、健康与情感角度深度解析，帮助成年伴侣了解身体知识、增进情感联结、提升亲密关系质量。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://c8p0.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '做爱指南',
    url: 'https://c8p0.cn',
    description: '专业性健康与亲密关系科普平台',
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a,
      },
    })),
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(siteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
            <img
              src={heroImage}
              alt="做爱指南 - 提升亲密关系质量的科学方法"
              title="做爱指南 - 亲密关系科学科普"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
            <div className="relative z-10 w-full text-center px-4 md:px-6">
              <h1 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4 md:mb-6">
                做爱指南
              </h1>
              <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-6 md:mb-8 leading-relaxed">
                从科学、健康与情感角度深度解析亲密关系，帮助成年伴侣了解身体知识、增进情感联结、提升亲密关系质量
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <Link
                  to="/category/sexual-health"
                  className="px-6 py-2.5 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  开始探索
                </Link>
                <Link
                  to="/about"
                  className="px-6 py-2.5 bg-white/15 text-white backdrop-blur-sm rounded-full text-sm font-medium hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer"
                >
                  了解更多
                </Link>
              </div>
            </div>
          </section>

          {/* Category Navigation */}
          <section className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-6xl mx-auto">
              <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 text-center mb-8">
                探索内容分类
              </h2>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="flex flex-col items-center gap-3 p-4 md:p-5 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300 group cursor-pointer"
                  >
                    <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-secondary-50 text-secondary-600 group-hover:bg-accent-100 group-hover:text-accent-600 transition-colors">
                      <i className={`${cat.icon} text-lg md:text-xl`}></i>
                    </div>
                    <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                      {cat.name}
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          {/* Featured Article */}
          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center justify-between mb-6">
                <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900">
                  精选推荐
                </h2>
                <Link
                  to={`/category/${featuredArticle.category}`}
                  className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
                >
                  查看更多 <i className="ri-arrow-right-line ml-1"></i>
                </Link>
              </div>
              <ArticleCard article={featuredArticle} variant="featured" />
            </div>
          </section>

          {/* Recent Articles */}
          <section className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-6xl mx-auto">
              <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-6">
                最新文章
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {recentArticles.map((article) => (
                  <ArticleCard key={article.slug} article={article} />
                ))}
              </div>
            </div>
          </section>

          {/* Expert Tips */}
          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="max-w-6xl mx-auto">
              <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 text-center mb-8">
                专家建议
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
                <div className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                    <i className="ri-shield-check-line text-lg"></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">科学为本</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    所有内容基于医学和心理学研究，确保信息的准确性和可靠性，帮助你建立科学的性知识体系。
                  </p>
                </div>
                <div className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mb-4">
                    <i className="ri-lock-line text-lg"></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">隐私安全</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    我们尊重每一位读者的隐私，所有浏览行为均匿名处理，不追踪个人阅读记录，让你安心获取所需知识。
                  </p>
                </div>
                <div className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4">
                    <i className="ri-heart-line text-lg"></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">专业关怀</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    内容由性健康专家和心理咨询师联合编写，以温暖专业的态度为你解答亲密关系中的困惑与疑虑。
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* FAQ */}
          <section className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-3xl mx-auto">
              <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 text-center mb-8">
                常见问题
              </h2>
              <div className="flex flex-col gap-3">
                {faqItems.map((item, index) => (
                  <details key={index} className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
                    <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                      <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                        {item.q}
                      </span>
                      <div className="w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 group-open:bg-primary-100 group-open:text-primary-600 transition-colors">
                        <i className="ri-arrow-down-s-line text-sm group-open:rotate-180 transition-transform"></i>
                      </div>
                    </summary>
                    <div className="px-4 md:px-5 pb-4 md:pb-5">
                      <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>

          {/* CTA */}
          <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
            <div className="max-w-2xl mx-auto text-center">
              <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-3">
                开始你的探索之旅
              </h2>
              <p className="text-sm md:text-base text-foreground-600 mb-6 leading-relaxed">
                无论你处在亲密关系的哪个阶段，这里都有适合你的知识。从基础科普到深度探讨，帮助你建立更健康、更满足的亲密关系。
              </p>
              <Link
                to="/category/sexual-health"
                className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                浏览全部文章 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}